export type { AesGcmCiphertext, EncryptedPrivateKeyBlob, RsaKeyPair } from './types';

export { AES_GCM_IV_BYTES, AES_GCM_PARAMS, PBKDF2_ITERATIONS, RSA_OAEP_PARAMS } from './constants';

export {
  aesGcmDecrypt,
  aesGcmDecryptBuffer,
  aesGcmEncrypt,
  aesGcmEncryptBuffer,
  deriveKeyFromRecoveryKey,
  deriveKeyFromVaultSecret,
  generateSalt,
} from './aes';

export { generateDek, unwrapDek, wrapDek } from './dek';
export { generateLinkKey, unwrapDekWithLinkKey, wrapDekWithLinkKey } from './link-key';
export { rewrapDekForRecipient } from './share';

export {
  checksumSha256,
  ciphertextToBase64,
  encryptFile,
  type EncryptedFileResult,
} from './upload';

export { arrayBufferToBase64, base64ToArrayBuffer, getWebCrypto } from './encoding';

export {
  generateEphemeralKeyPair,
  generateRsaKeyPair,
  importPrivateKey,
  importPrivateKeyFromPem,
  importPublicKeyFromPem,
  rsaOaepDecrypt,
  rsaOaepEncrypt,
} from './rsa';

export {
  decryptPrivateKey,
  decryptVaultPayload,
  decryptWithRecoveryKey,
  encryptPrivateKey,
  encryptWithRecoveryKey,
  generateRecoveryKey,
  generateVaultSecret,
} from './vault';
